import { render, staticRenderFns } from "./listLayout.vue?vue&type=template&id=47485976&scoped=true&"
import script from "./listLayout.vue?vue&type=script&lang=js&"
export * from "./listLayout.vue?vue&type=script&lang=js&"
import style0 from "./listLayout.vue?vue&type=style&index=0&id=47485976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47485976",
  null
  
)

export default component.exports